import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, Renderer2, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-tab-filter',
  templateUrl: './tab-filter.component.html',
  styleUrls: ['./tab-filter.component.scss'],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  standalone: true
})
export class TabFilterComponent implements OnChanges {

  @Input() tabs: string[] = []
  @Input() defaultWidth: number = 100
  @Input() defaultTab: string
  @Output() selectedTab: EventEmitter<string> = new EventEmitter<string>();

  activeIndex: number = 0;

  constructor(private _renderer: Renderer2) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['defaultTab']) {
      let idx = this.tabs.findIndex((el) => {
        return el === this.defaultTab
      })

      if (idx >= 0) {
        setTimeout(() => {
          this.changeTab(idx)
        },)
      }

      this.selectedTab.emit(this.defaultTab)
    }
    else {
      this.selectedTab.emit(this.tabs[0])
    }
  }

  @ViewChild('activeTab') activeTab!: ElementRef;
  @ViewChildren('btn') buttons!: QueryList<ElementRef>

  ngAfterViewInit(): void {
    this.buttons.forEach((button, index) => {
      button.nativeElement.addEventListener('click', () => {
        this.changeTab(index)
      })
    })
  }

  changeTab(index: number): void {
    this.activeIndex = index;
    let move = `${(100 / this.tabs.length) * index}%`
    this._renderer.setStyle(this.activeTab.nativeElement, 'left', move)
    if(move === '0%') {
    this._renderer.setStyle(this.activeTab.nativeElement, 'transform', `translateX(5px)`)
    }
    else {
      this._renderer.setStyle(this.activeTab.nativeElement, 'transform', `translateX(1px)`)
    }
  
    this.selectedTab.emit(this.tabs[index])
  }

}
